import React, { useEffect } from "react";
import Sidebar from "../../components/SideBar";
import Navbar from "../../components/NavBar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DoctorsRequests = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (window.localStorage.getItem("auth_token") === null) navigate("/login");
  }, [navigate]);

  const token = window.localStorage.getItem("auth_token");
  return (
    <>
      {token && (
        <div className="d-flex">
          <div>
            <Sidebar />
          </div>

          <div
            style={{
              flex: "1 1 auto",
              display: "flex",
              flexFlow: "column",
              height: "100vh",
              overflowY: "hidden",
            }}
          >
            <Navbar />
            <div style={{ height: "100%" }}>
              <div
                style={{
                  padding: "20px 5%",
                  height: "calc(100% - 64px)",
                  overflowY: "scroll",
                }}
              >
                <p>
                  {t(
                    "this is the page to manage the doctors: remove && create doctors",
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {!token && <div className="login-container"></div>}
    </>
  );
};

export default DoctorsRequests;
